export type DeviceTypeOptions = 'mobile' | 'desktop';

export enum DeviceType {
  MOBILE = 'mobile',
  DESKTOP = 'desktop',
}
